/* ════════════════════════════════════════════════════════════════════════
   GOB EXPERIENCE — V153, 2026-10-19
   The moments around the cart, built on gob-smooth.js (V152). Same colours,
   same type, same components — only how they arrive, react and leave.

   1. LIGHTS ON — on Add to cart the product photo flies into the drawer and the
      thumbnail "switches on" (a warm amber glow), the brand's own metaphor.
   2. UNDO — removing a kit shows "Removed · Undo" for 6 s; Undo puts the exact
      line back (version, quantity, properties).
   3. SWIPE — on a phone the drawer follows the finger and closes with a swipe
      to the right.
   4. HEADER COUNT — "Your Cart · 2 items", rolling when it changes.
   5. EMPTY STATE — a real empty state instead of €0,00 and a Check out button
      (that was a live bug: a later CSS rule un-hid the form): set search,
      Shop light kits, Bestsellers.
   6. QUANTITY — while a quantity is being saved the line price and subtotal
      dim, so the number never looks wrong; the paint brings them back.
   7. CLUB — when GOB Club is applied in the drawer a single light sweep runs
      across the Club bar and the savings line.
   8. CHECK OUT — the button answers the tap at once ("Securing checkout…")
      while the guards in front of checkout do their work.
   9. OPEN — rows and footer rise into place when the drawer opens.
  10. PRODUCT PAGE — switching version rolls the price; buttons press.
   prefers-reduced-motion: everything still works, nothing moves.
   Styles: assets/gob-experience.css. Loaded by snippets/gob-smooth-head.liquid.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.GOBExperience) return;
  var W = window, D = document, H = D.documentElement;
  var X = W.GOBExperience = { v: 153 };
  var RM = W.matchMedia ? W.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function calm() { return !!(RM && RM.matches) || !Element.prototype.animate; }
  var EASE = 'cubic-bezier(.25,.1,.25,1)', FLY = 'cubic-bezier(.2,.7,.15,1)';
  function q(s, r) { return (r || D).querySelector(s); }
  function qa(s, r) { return [].slice.call((r || D).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function root() { return ((W.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/'); }
  function drawer() { return D.getElementById('HeaderCart'); }
  function isOpen() { var d = drawer(); return !!(d && d.classList.contains('is-active')); }
  function S() { return W.GOBSmooth || {}; }
  function ready(fn) { if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', fn); else fn(); }

  /* ───────── 1. lights on: fly the photo into the drawer ───────── */
  function visibleArea(r) {
    var w = Math.max(0, Math.min(r.right, innerWidth) - Math.max(r.left, 0));
    var h = Math.max(0, Math.min(r.bottom, innerHeight) - Math.max(r.top, 0));
    return w * h;
  }
  function sourceImage(form) {
    var best = null, area = 0;
    qa('main img').forEach(function (im) {
      if (!im.complete || !im.naturalWidth || im.closest('#HeaderCart, header, .site-header, .gob-np')) return;
      var r = im.getBoundingClientRect();
      if (r.width < 140 || r.height < 100) return;
      var a = visibleArea(r);
      if (a > area && a > r.width * r.height * 0.35) { area = a; best = { el: im, r: r }; }
    });
    return best;
  }
  function lightsOn(thumb) {
    if (!thumb) return;
    thumb.classList.remove('gx-await');
    if (calm()) return;
    thumb.animate([
      { filter: 'brightness(.5) saturate(.6)', boxShadow: '0 0 0 0 rgba(247,183,51,0)' },
      { filter: 'brightness(1.18) saturate(1.1)', boxShadow: '0 0 0 5px rgba(247,183,51,.38), 0 0 26px 4px rgba(247,183,51,.45)', offset: .45 },
      { filter: 'none', boxShadow: '0 0 0 0 rgba(247,183,51,0)' }
    ], { duration: 1100, easing: EASE });
  }
  X.lightsOn = lightsOn;

  /* V154 (Markas): no flying photo. The new line simply appears in the cart —
     a short fade and an 8px rise, the same motion as the GOB Club row. A line
     whose quantity went up does not move; its number rolls (V152). */
  D.addEventListener('gob:adding', function (e) {
    var d = e.detail || {}, row = d.row;
    if (!row || d.existing || calm() || !row.animate) return;
    row.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }],
      { duration: 460, delay: 120, easing: EASE, fill: 'backwards' });
  });
  /* a row that replaces the pending one keeps the glow going */
  D.addEventListener('gob:cart-painted', function () {
    qa('#HeaderCart .gx-await').forEach(function (t) { t.classList.remove('gx-await'); });
  });

  /* ───────── 2. undo a removal ───────── */
  var undoT = null;
  function lineFor(key) {
    var c = S().lastCart;
    if (!c || !c.items) return null;
    return c.items.filter(function (i) { return i.key === key; })[0] || null;
  }
  function isRemoval(el) {
    if (!el || !el.closest('#HeaderCart')) return false;
    if (el.closest('.cart__remove, [data-cart-remove], [data-remove], .gob-remove')) return true;
    if (el.closest('.js-qty__adjust--minus')) {
      var w = el.closest('.js-qty__wrapper'), inp = w && q('input', w);
      return !!(inp && parseInt(inp.value, 10) === 1);
    }
    return false;
  }
  /* V156 (Markas): no Undo toast after removing a kit, the line simply leaves.
     Set UNDO = true to bring the 6 s "Removed · Undo" toast back. */
  var UNDO = false;
  D.addEventListener('click', function (e) {
    if (!UNDO) return;
    var t = e.target;
    if (!t || !t.closest || !isRemoval(t)) return;
    var row = t.closest('[data-key]');
    if (!row || row.classList.contains('gob-mt')) return;            /* the Club has its own remove */
    var line = lineFor(row.getAttribute('data-key'));
    if (!line) return;
    var name = (q('.cart__item-name', row) || {}).textContent || line.product_title || '';
    X.pendingUndo = { line: line, name: name.replace(/\s+/g, ' ').trim(), at: Date.now() };
  }, true);
  D.addEventListener('gob:cart-painted', function () {
    var u = X.pendingUndo;
    if (!u || Date.now() - u.at > 8000) return;
    if (q('#HeaderCart .cart__item[data-key="' + u.line.key + '"]:not(.gs-leaving)')) return;   /* not removed (yet) */
    X.pendingUndo = null;
    toast(u);
  });
  function toast(u) {
    var d = drawer(); if (!d) return;
    var host = q('.site-header__drawer-animate', d) || d;
    var old = q('.gx-toast', host); if (old) old.remove();
    clearTimeout(undoT);
    var el = D.createElement('div');
    el.className = 'gx-toast'; el.setAttribute('role', 'status');
    el.innerHTML = '<span class="gx-toast__t"><b>Removed</b> ' + esc(u.name) + '</span><button type="button" class="gx-toast__u">Undo</button><i class="gx-toast__bar" aria-hidden="true"></i>';
    var head = q('.gob-drawer-head', host);
    host.appendChild(el);
    var hb = head ? head.getBoundingClientRect().bottom : 0, tb = host.getBoundingClientRect().top;
    el.style.top = Math.max(8, (hb ? hb - tb : 56) + 8) + 'px';
    var gone = function () {
      if (!el.parentNode) return;
      if (calm()) { el.remove(); return; }
      el.classList.add('is-out'); setTimeout(function () { el.remove(); }, 260);
    };
    undoT = setTimeout(gone, 6000);
    q('.gx-toast__u', el).addEventListener('click', function () {
      clearTimeout(undoT);
      var b = this; b.disabled = true; b.textContent = 'Restoring…';
      var it = { id: u.line.variant_id, quantity: u.line.quantity };
      var props = u.line.properties || {};
      if (props && Object.keys(props).length) it.properties = props;
      if (u.line.selling_plan_allocation && u.line.selling_plan_allocation.selling_plan) it.selling_plan = u.line.selling_plan_allocation.selling_plan.id;
      var addUrl = (W.theme && theme.routes && theme.routes.cartAdd) || root() + 'cart/add.js';
      fetch(addUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [it] }) })
        .then(function (r) { return r.json(); })
        .then(function () {
          gone();
          var sync = S().syncAddons ? S().syncAddons(true) : Promise.resolve();
          return sync.then(function () { D.dispatchEvent(new CustomEvent('cart:build')); D.dispatchEvent(new CustomEvent('cart:updated')); });
        })
        .catch(function () { b.disabled = false; b.textContent = 'Undo'; });
    });
  }

  /* ───────── 3. swipe the drawer away (touch) ───────── */
  function swipe() {
    var d = drawer();
    if (!d || d.__gxSwipe || !('ontouchstart' in W)) return;
    d.__gxSwipe = 1;
    var x0 = 0, y0 = 0, t0 = 0, dx = 0, mode = '', ov = null;
    function scrollerX(el) {
      for (var n = el; n && n !== d; n = n.parentElement) {
        if (n.scrollWidth > n.clientWidth + 2) { var o = getComputedStyle(n).overflowX; if (o === 'auto' || o === 'scroll') return true; }
      }
      return false;
    }
    d.addEventListener('touchstart', function (e) {
      if (!isOpen() || e.touches.length !== 1 || calm()) { mode = 'off'; return; }
      var t = e.touches[0];
      if (t.target.closest && (t.target.closest('input, textarea, select, [type=range]') || scrollerX(t.target))) { mode = 'off'; return; }
      x0 = t.clientX; y0 = t.clientY; t0 = Date.now(); dx = 0; mode = ''; ov = D.getElementById('gob-cart-overlay');
    }, { passive: true });
    d.addEventListener('touchmove', function (e) {
      if (mode === 'off' || mode === 'y') return;
      var t = e.touches[0], mx = t.clientX - x0, my = t.clientY - y0;
      if (!mode) {
        if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
        mode = (mx > 0 && Math.abs(mx) > Math.abs(my) * 1.2) ? 'x' : 'y';
        if (mode !== 'x') return;
        d.style.setProperty('transition', 'none', 'important');
        if (ov) ov.style.transition = 'none';
      }
      dx = Math.max(0, mx);
      d.style.setProperty('transform', 'translateX(' + dx + 'px)', 'important');
      if (ov) ov.style.opacity = String(Math.max(0, 1 - dx / (d.offsetWidth * 0.9)));
    }, { passive: true });
    function end() {
      if (mode !== 'x') { mode = ''; return; }
      mode = '';
      var v = dx / Math.max(1, Date.now() - t0), w = d.offsetWidth;
      var close = dx > w * 0.3 || (v > 0.45 && dx > 40);
      d.style.setProperty('transition', 'transform ' + (close ? '.24s cubic-bezier(.4,0,1,1)' : '.32s ' + EASE), 'important');
      d.style.setProperty('transform', close ? 'translateX(100%)' : 'translateX(0)', 'important');
      if (ov) { ov.style.transition = 'opacity .28s ease'; ov.style.opacity = close ? '0' : ''; }
      setTimeout(function () {
        if (close) { if (W.gobCloseCart) W.gobCloseCart(); else D.dispatchEvent(new CustomEvent('cart:close')); }
        requestAnimationFrame(function () {
          d.style.removeProperty('transition'); d.style.removeProperty('transform');
          if (ov) { ov.style.transition = ''; ov.style.opacity = ''; }
        });
      }, close ? 250 : 330);
    }
    d.addEventListener('touchend', end, { passive: true });
    d.addEventListener('touchcancel', end, { passive: true });
  }

  /* ───────── 4. header count ───────── */
  function count() {
    var d = drawer(); if (!d) return;
    var head = q('.gob-drawer-head', d); if (!head) return;
    /* kits only: the Club line is a membership, not an item */
    var n = 0;
    qa('.cart__items > .cart__item[data-key]:not(.gob-mt):not(.gs-leaving)', d).forEach(function (r) {
      var v = parseInt((q('.js-qty__num', r) || {}).value, 10);
      n += v > 0 ? v : 1;
    });
    var c = q('.gx-count', head);
    if (!c) { c = D.createElement('span'); c.className = 'gx-count'; var b = q('b', head); if (b) b.after(c); else head.prepend(c); }
    var txt = n ? (n + (n === 1 ? ' item' : ' items')) : '';
    if (c.textContent === txt) return;
    var had = !!c.textContent;
    c.textContent = txt;
    c.classList.toggle('is-on', !!n);
    if (had && txt && !calm() && S().rise) S().rise(c, 0);
  }

  /* ───────── 5. empty state ───────── */
  function empty() {
    var d = drawer(); if (!d) return;
    var e = q('.site-header__cart-empty', d);
    if (!e || e.__gx) return;
    e.__gx = 1;
    var r = root();
    e.innerHTML =
      '<div class="gx-empty">' +
        '<svg class="gx-empty__i" viewBox="0 0 64 64" aria-hidden="true">' +
          '<circle class="g" cx="32" cy="27" r="20"/>' +
          '<path class="o" d="M24 33.5c-3.2-2.4-5.2-6-5.2-10.1C18.8 16 24.7 10 32 10s13.2 6 13.2 13.4c0 4.1-2 7.7-5.2 10.1-1.4 1-2.2 2.6-2.2 4.3V40H26.2v-2.2c0-1.7-.8-3.3-2.2-4.3z"/>' +
          '<path class="o" d="M26.5 45h11M28 50h8"/>' +
          '<path class="f" d="M28.5 30l3.5-6 3.5 6"/>' +
        '</svg>' +
        '<p class="gx-empty__h">Your cart is empty</p>' +
        '<p class="gx-empty__s">Find the light kit made for your set.</p>' +
        '<form class="gx-empty__f" action="' + r + 'search" method="get" role="search">' +
          '<input type="search" name="q" placeholder="Set number or name" aria-label="Set number or name" autocomplete="off" inputmode="search">' +
          '<button type="submit" aria-label="Search"><svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="8.5" cy="8.5" r="5.5"/><path d="M13 13l4 4"/></svg></button>' +
        '</form>' +
        '<a class="gx-empty__cta" href="' + r + 'collections/lego-light-kits">Shop light kits</a>' +
        '<a class="gx-empty__alt" href="' + r + 'collections/bestsellers">See bestsellers</a>' +
      '</div>';
  }

  /* ───────── 6. quantity: dim what is being recalculated ───────── */
  D.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.js-qty__adjust');
    if (!b || !b.closest('#HeaderCart, .cart__page, form[action*="/cart"]')) return;
    var row = b.closest('.cart__item'), form = b.closest('form');
    if (row) row.classList.add('gx-updating');
    if (form) form.classList.add('gx-recalc');
  }, true);
  D.addEventListener('gob:cart-painted', function () {
    qa('.gx-updating').forEach(function (r) { r.classList.remove('gx-updating'); });
    qa('.gx-recalc').forEach(function (f) { f.classList.remove('gx-recalc'); });
  });

  /* ───────── 7. Club applied: one light sweep ───────── */
  var clubWas = H.classList.contains('gob-club-on'), sweepDue = false;
  new MutationObserver(function () {
    var on = H.classList.contains('gob-club-on');
    if (on && !clubWas && isOpen()) sweepDue = true;
    clubWas = on;
  }).observe(H, { attributes: true, attributeFilter: ['class'] });
  function sweep() {
    if (!sweepDue || calm()) { sweepDue = false; return; }
    sweepDue = false;
    var t = qa('#HeaderCart .gobcr__bar, #HeaderCart .cart__item.gob-mt, #HeaderCart .gob-save-row');
    t.forEach(function (el, i) {
      setTimeout(function () {
        if (!el.isConnected) return;
        var cs = getComputedStyle(el), pos = el.style.position, ovf = el.style.overflow;
        if (cs.position === 'static') el.style.position = 'relative';
        el.style.overflow = 'hidden';
        var sh = D.createElement('i'); sh.className = 'gx-sheen'; sh.setAttribute('aria-hidden', 'true');
        el.appendChild(sh);
        var a = sh.animate([{ transform: 'translateX(-120%) skewX(-18deg)' }, { transform: 'translateX(320%) skewX(-18deg)' }], { duration: 1100, easing: 'cubic-bezier(.4,0,.2,1)' });
        a.onfinish = a.oncancel = function () { sh.remove(); el.style.position = pos; el.style.overflow = ovf; };
      }, 120 + i * 150);
    });
  }
  D.addEventListener('gob:cart-painted', function () { setTimeout(sweep, 260); });

  /* ───────── 8. check out answers at once ───────── */
  /* window, capture: runs before the checkout handlers that stop the event */
  W.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('button[name="checkout"], .cart__checkout');
    if (!b || b.classList.contains('gx-going')) return;
    var terms = b.form && q('.cart__terms-checkbox', b.form);
    if (terms && !terms.checked) return;
    b.style.setProperty('--gx-fg', getComputedStyle(b).color);
    if (getComputedStyle(b).position === 'static') b.style.position = 'relative';
    b.classList.add('gx-going');
    var m = D.createElement('span'); m.className = 'gx-going__m'; m.setAttribute('role', 'status');
    m.innerHTML = '<i class="gx-spin" aria-hidden="true"></i>Securing checkout…';
    b.appendChild(m);
    setTimeout(function () { reset(b); }, 9000);
  }, true);
  function reset(b) { b.classList.remove('gx-going'); var m = q('.gx-going__m', b); if (m) m.remove(); }
  W.addEventListener('pageshow', function (e) { if (e.persisted) qa('.gx-going').forEach(reset); });

  /* ───────── 9. open: rows and footer rise ───────── */
  D.addEventListener('CartDrawer:open', function () {
    if (calm()) return;
    var sm = S();
    if (sm.lastAdd && Date.now() - sm.lastAdd < 1500) return;      /* Add to cart has its own choreography */
    var d = drawer(); if (!d) return;
    var els = qa('.cart__items > .cart__item, .cart__items > .gob-np', d).slice(0, 6);
    var f = q('.cart__footer', d); if (f) els.push(f);
    var gx = q('.gx-empty', d); if (gx && d.querySelector('.is-empty')) els = [gx];
    els.forEach(function (el, i) {
      el.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }],
        { duration: 460, delay: 120 + i * 45, easing: EASE, fill: 'backwards' });
    });
  });

  /* ───────── 10. product page: the price rolls when the version changes ───────── */
  function pdp() {
    var box = q('.gobd1 .d-pricearea');
    if (!box || box.__gx) return;
    box.__gx = 1;
    var last = box.textContent.replace(/\s+/g, ''), raf = 0, pick = 0;
    /* only after the shopper picks a version — never on the page's own load-time paints */
    D.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('.gobd1, [data-variant-input]')) pick = Date.now(); }, true);
    D.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('.gobd1 .d-v')) pick = Date.now(); }, true);
    new MutationObserver(function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var now = box.textContent.replace(/\s+/g, '');
        if (now === last) return;
        last = now;
        if (calm() || Date.now() - pick > 1500 || H.classList.contains('gcm-in') || H.classList.contains('gcm-out')) return;   /* the Club toggle has its own roll */
        qa('.d-pl, .gob-mp:not(.gob-mp--guest), .gob-mp--guest', box).forEach(function (el, i) {
          if (!el.offsetParent) return;
          el.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 420, delay: i * 70, easing: EASE, fill: 'backwards' });
        });
      });
    }).observe(box, { childList: true, subtree: true, characterData: true });
  }

  function boot() { swipe(); count(); empty(); pdp(); }
  ready(boot);
  D.addEventListener('gob:cart-painted', function () { count(); setTimeout(count, 420); });
  D.addEventListener('CartDrawer:open', function () { swipe(); count(); empty(); });
})();
